<template>
  <div>

    <!-- Data Stores Hack, need to be loaded first -->
    <ShiftStore ref="shiftStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Shifts</h1>
    
    Show Data Entry: <input type="checkbox" v-model="ls.showDataEntry" /> 
    Show Transaction Counts: <input type="checkbox" v-model="ls.showTransCounts" />
    Number Of Shifts: <input v-model="ls.numOfShifts" />
    <div v-for="location in ['WGB']" :key="location">
      <Shift 
        :location="location" 
        :showDataEntry="ls.showDataEntry" 
        :showTransCounts="ls.showTransCounts" 
        :numOfShifts="ls.numOfShifts" 
      />
    </div>
  </div>
</template>

<script>
import Shift from '@/pages/Reports/Shifts/Components/Shift.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  mixins: [localstorageMixin],
  components : {Shift, ShiftStore},
  name: 'ShiftsPage',
  provide() {
    return {
      shiftsPage: this
    }
  },
  data () { return { 
    ls: {
      showDataEntry: false,
      showTransCounts: false,
      numOfShifts: 10,
    },
    } 
  },

}
</script>